import { timeAgo } from '../shared/date';

const trackedEmailMapper = {
    toDomain(data) {
        return {
            id: data.id,
            email: data.email,
            totalBreaches: data.totalBreaches,
            resolvedBreaches: data.resolvedBreaches,
            lastCheckedTimeAgo: timeAgo(data.lastCheckedAt)
        }
    }
};

export {
    trackedEmailMapper
};
